// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "app/styles/" + chunkId + "." + {"1734": "9e6c41affcaf01cb","2341": "eddd9562cc19a835",}[chunkId] + ".css"
}